import { startOfDay } from "./statisticsDateFilter.util";

/** Local calendar day as `YYYY-MM-DD` (matches date picker cells). */
export function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function todayUtcYmd(): string {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, "0");
  const day = String(now.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function minYmd(a: string, b: string): string {
  return a <= b ? a : b;
}

/**
 * Maps analytics bounds (local start/end of day) to API `from` / `to` (inclusive).
 * Clamps `to` to today UTC so the API never receives a future day.
 */
export function boundsToApiDateRange(bounds: {
  start: Date;
  end: Date;
}): { from: string; to: string } {
  const from = formatLocalYmd(startOfDay(bounds.start));
  const toRaw = formatLocalYmd(startOfDay(bounds.end));
  const to = minYmd(toRaw, todayUtcYmd());
  return { from, to };
}

export function daysInclusiveLocalYmd(fromYmd: string, toYmd: string): number {
  const [fy, fm, fd] = fromYmd.split("-").map(Number);
  const [ty, tm, td] = toYmd.split("-").map(Number);
  const t1 = new Date(fy, fm - 1, fd).getTime();
  const t2 = new Date(ty, tm - 1, td).getTime();
  return Math.round((t2 - t1) / (24 * 60 * 60 * 1000)) + 1;
}

/** Previous window of the same length (inclusive local days), ending the day before `from`. */
export function previousPeriodInclusive(
  fromYmd: string,
  toYmd: string,
): { from: string; to: string } {
  const n = daysInclusiveLocalYmd(fromYmd, toYmd);
  const [y, m, d] = fromYmd.split("-").map(Number);
  const fromDate = new Date(y, m - 1, d);
  const prevTo = new Date(fromDate);
  prevTo.setDate(prevTo.getDate() - 1);
  const prevFrom = new Date(prevTo);
  prevFrom.setDate(prevFrom.getDate() - (n - 1));
  return {
    from: formatLocalYmd(prevFrom),
    to: formatLocalYmd(prevTo),
  };
}
